// Validates a redirect target captured from a URL query param so we
// never bounce the user to an attacker-controlled origin after login.
// Rules:
//   - Must be a non-empty string.
//   - Must start with a single "/" (same-origin, absolute path).
//   - Must NOT start with "//" (protocol-relative — would resolve off-origin).
// Anything else returns null, callers fall back to a known-safe default.
export function safeRedirectTarget(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (!raw.startsWith('/')) return null;
  if (raw.startsWith('//')) return null;
  return raw;
}
